module.exports = __webpack_public_path__ + "static/media/icon_cart_dark.f54e7603.svg";